<template>
  <ClientOnly>
    <component :is="icon" :class="classes" :component-id="componentId" />
  </ClientOnly>
</template>

<script>
import { v4 as uuidv4 } from 'uuid'

import Analytics from './icons/Analytics'
import AudioToVideo from './icons/AudioToVideo'
import Collaborators from './icons/Collaborators'
import Distribution from './icons/Distribution'
import EmbeddablePlayer from './icons/EmbeddablePlayer'
import Hosting from './icons/Hosting'
import Monetization from './icons/Monetization'
import Podcasting20 from './icons/Podcasting20'
import Privacy from './icons/Privacy'
import SocialMediaSharing from './icons/SocialMediaSharing'
import Transcription from './icons/Transcription'
import Website from './icons/Website'
import Business from './icons/Business'
import Education from './icons/Education'
import HealthAndFitness from './icons/HealthAndFitness'
import PersonalJournal from './icons/PersonalJournal'
import Sports from './icons/Sports'
import Technology from './icons/Technology'
import TrueCrime from './icons/TrueCrime'
import News from './icons/News.vue'
import SocietyAndCulture from './icons/SocietyAndCulture.vue'
import Comedy from './icons/Comedy.vue'
import ArrowRight from './icons/ArrowRight'
import PodcastSupport from './icons/PodcastSupport'
import Pause from './icons/Pause'
import MagnifyingGlass from './icons/MagnifyingGlass'
import Reload from './icons/Reload'
import Religion from './icons/Religion'
import Paid from './icons/Paid'
import AnalyticsGradient from './icons/AnalyticsGradient'
import LiveGradient from './icons/LiveGradient'
import MonetizationGradient from './icons/MonetizationGradient'
import PrivacyGradient from './icons/PrivacyGradient'
import RocketGradient from './icons/RocketGradient'
import WebsiteGradient from './icons/WebsiteGradient'
import PurpleCursor from './icons/PurpleCursor'
import BlueBrush from './icons/BlueBrush'

export default {
  components: {
    Analytics,
    AudioToVideo,
    Collaborators,
    Distribution,
    EmbeddablePlayer,
    Hosting,
    Monetization,
    Podcasting20,
    Privacy,
    SocialMediaSharing,
    Transcription,
    Website,
    News,
    Business,
    Education,
    HealthAndFitness,
    PersonalJournal,
    Sports,
    Technology,
    TrueCrime,
    SocietyAndCulture,
    Comedy,
    ArrowRight,
    PodcastSupport,
    Pause,
    MagnifyingGlass,
    Reload,
    Religion,
    Paid,
    AnalyticsGradient,
    LiveGradient,
    MonetizationGradient,
    PrivacyGradient,
    RocketGradient,
    WebsiteGradient,
    PurpleCursor,
    BlueBrush
  },

  props: {
    name: {
      type: String,
      required: true
    },
    size: {
      type: String,
      default: 'medium'
    }
  },

  computed: {
    icon () {
      return this.name.charAt(0).toUpperCase() + this.name.slice(1)
    },

    classes () {
      return ['commonIcon', `commonIcon_${this.size ? this.size : 'medium'}`]
    },

    componentId () {
      return uuidv4()
    }
  }
}
</script>

<style lang="scss" scoped>
.commonIcon {
  vertical-align: middle;

  &_medium {
    width: 24px;
    height: 24px;
  }

  &_large {
    width: 32px;
    height: 32px;
  }

  &_extraLarge {
    width: 40px;
    height: 40px;
  }
}
</style>
